<template>
  <p>
    <span class="d-block fst-italic">
      <i class="d-inline-block me-1 bi-calendar3"></i>
      {{ appViewHelper.formatDateTime(work.createdAt, 'DATE_SHORT') }}</span
    >
    <span class="fw-bold">
      <i class="d-inline-block me-1 bi-arrow-left-right"></i>
      Substituição de equipamento
    </span>
  </p>
  <p>Esse equipamento foi substituído.</p>
  <p>OS: {{ appViewHelper.format(work.workOrder) }}</p>
  <WorkReportWorkObservationsField
    class="mb-3"
    :work="work"
    :isEditable="isEditable"
  />
  <template v-if="beforeWorkAttachmentCollections.length > 0">
    <WorkReportAttachmentCollection
      v-for="attachmentCollection in beforeWorkAttachmentCollections"
      :key="attachmentCollection._id"
      title="Fotos (antes)"
      :attachmentCollection="attachmentCollection"
      :token="token"
      :workspace="workspace"
    />
  </template>
  <template v-if="afterWorkAttachmentCollections.length > 0">
    <WorkReportAttachmentCollection
      v-for="attachmentCollection in afterWorkAttachmentCollections"
      :key="attachmentCollection._id"
      title="Fotos (depois)"
      :attachmentCollection="attachmentCollection"
      :token="token"
      :workspace="workspace"
    />
  </template>
</template>

<script>
import appViewHelper from '../view_helpers/app_view_helper';
import i18n from '../i18n/i18n';
import WorkReportAttachmentCollection from './WorkReportAttachmentCollection';
import WorkReportWorkObservationsField from './WorkReportWorkObservationsField';

export default {
  name: 'WorkReportProductReplacement',
  components: {
    WorkReportAttachmentCollection,
    WorkReportWorkObservationsField,
  },
  props: {
    work: {
      type: Object,
      required: true,
    },
    token: {
      type: String,
      required: true,
    },
    workspace: {
      type: String,
      required: true,
    },
    isEditable: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    return {
      appViewHelper,
      i18n,
    };
  },
  data() {
    return {};
  },
  computed: {
    beforeWorkAttachmentCollections() {
      return this.filterAttachments('beforeProductReplacement');
    },
    afterWorkAttachmentCollections() {
      return this.filterAttachments('afterProductReplacement');
    },
  },
  methods: {
    filterAttachments(...types) {
      if (this.work.attachments === undefined) return [];

      return this.work.attachments.filter((att) =>
        att.labels.includes(types[0])
      );
    },
  },
};
</script>
